import { el } from '../lib/dom.js';

/** Badge para status ATIVO/INATIVO. */
export function badgeStatus(status) {
  const ativo = status === 'ATIVO';
  return el('span', { class: `badge ${ativo ? 'badge--ok' : 'badge--off'}`, text: ativo ? 'Ativo' : 'Inativo' });
}

/** Badge para situação DISPONIVEL/RETIRADA da chave. */
export function badgeSituacao(situacao) {
  const disp = situacao === 'DISPONIVEL';
  return el('span', { class: `badge ${disp ? 'badge--ok' : 'badge--alerta'}`, text: disp ? 'Disponível' : 'Retirada' });
}
